module.exports = __webpack_public_path__ + "static/img/16.dbdd9dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/16.png
// module id = 6uXX
// module chunks = 0